import Vue from "vue";
import dateTime from 'date-and-time';
import { dateInDjangoFormat, getPreviousDate, getDayMonthFromDate, getPreviousYear, addDaysToDate } from "../utils/datetime-handling";

dateTime.extend({
  parser: {
    YY: function (str) {
      var result = this.exec(/^\d{1,2}/, str);
      result.value += result.value < 70 ? 2000 : result.value < 100 ? 1900 : 0;
      return result;
    }
  }
})

Vue.mixin({
  data() {
    return {
      dateInDjangoFormat,
      getPreviousDate,
      getPreviousYear,
      getDayMonthFromDate,
      addDaysToDate
    }
  },
  computed: {
    todayDjangoFormat() {
      // Want to get today's date in the YYYY-MM-DD format for comparison with django dates
      let today = new Date();
      return (
        today.getFullYear().toString() +
        "-" +
        ("0" + (today.getMonth() + 1).toString()).slice(-2) +
        "-" +
        ("0" + today.getDate().toString()).slice(-2)
      );
    },
    todayDatetimeDjangoFormat() {
      // Want to get today's date in the YYYY-MM-DD format for comparison with django dates
      let today = new Date();
      return (
        today.getFullYear().toString() +
        "-" +
        ("0" + (today.getMonth() + 1).toString()).slice(-2) +
        "-" +
        ("0" + today.getDate().toString()).slice(-2) +
        "T" +
        today.getHours() +
        ":" +
        today.getMinutes() +
        ":" +
        today.getSeconds()
      );
    }
  },
  methods: {
    getDateString(date) {
      if (!date) {
        return '';
      }
      const dateObj = this.addCurrentTimeToDate(date);
      const result = dateObj.toLocaleString(this.$store.getters.languageLocal, { month: 'short', year: 'numeric', weekday: 'short', day: '2-digit' });
      if (!result) {
        return dateObj.toDateString();
      }
      return this.replaceAllText(this.capitalizeFirstLetter(result), ', ', ' ');
    },
    getDateTimeString(input) {
      const dateObj = new Date(input);
      return dateObj.toDateString() + ' at ' + dateObj.toLocaleTimeString();
    },
    compressDateFormat(date) {
      const dateObject = this.addCurrentTimeToDate(date);
      const day = dateObject.getDate();
      const month = dateObject.getMonth() + 1;
      return `${month}/${day}`;
    },
    addCurrentTimeToDate(date) {
      if (typeof date === 'object') {
        return date;
      }
      let today = new Date();
      let hourNow = today.getHours();
      // https://stackoverflow.com/questions/18889548/javascript-change-gethours-to-2-digit
      // Need to make sure each of these values is 2 digits, otherwise it breaks the human date generation below
      hourNow = ("0" + hourNow).slice(-2);
      let minuteNow = today.getMinutes();
      minuteNow = ("0" + minuteNow).slice(-2);
      let secondNow = today.getMinutes();
      secondNow = ("0" + secondNow).slice(-2);

      return new Date(
        date
          .concat("T")
          .concat(hourNow)
          .concat(":")
          .concat(minuteNow)
          .concat(":")
          .concat(secondNow)
      );
    },
    convertTimeFormat(str) {
      //convert AM/PM to military time (ie. 19:00:00)
      let time = str;
      let hours = Number(time.match(/^(\d+)/)[1]);
      let minutes = Number(time.match(/:(\d+)/)[1]);
      let AMPM = time.match(/\s(.*)$/)[1];
      if (AMPM == "PM" && hours < 12) hours = hours + 12;
      if (AMPM == "AM" && hours == 12) hours = hours - 12;
      let sHours = hours.toString();
      let sMinutes = minutes.toString();
      if (hours < 10) sHours = "0" + sHours;
      if (minutes < 10) sMinutes = "0" + sMinutes;
      return `${sHours}:${sMinutes}:00`;
    },
    // https://stackoverflow.com/questions/8888491/how-do-you-display-javascript-datetime-in-12-hour-am-pm-format
    formatAMPM(date) {
      // Take a javascript date and spit out the time in AMPM format
      var hours = date.getHours();
      var minutes = date.getMinutes();
      var ampm = hours >= 12 ? "pm" : "am";
      hours = hours % 12;
      hours = hours ? hours : 12; // the hour '0' should be '12'
      minutes = minutes < 10 ? "0" + minutes : minutes;
      var strTime = hours + ":" + minutes + " " + ampm;
      return strTime;
    },
    djangotimeformatAMPM(djangotime) {
      // Take a django 24 hour time and return it in AMPM format
      // console.log(djangotime)
      if (djangotime) {
        var hours = djangotime.split(":")[0];
        var minutes = djangotime.split(":")[1];
        var ampm = hours >= 12 ? "pm" : "am";
        hours = hours % 12;
        hours = hours ? hours : 12; // the hour '0' should be '12'
        // minutes = minutes < 10 ? '0'+minutes : minutes; // minutes are already padded in django time
        var strTime = hours + ":" + minutes + " " + ampm;
        return strTime;
      } else {
        return '';
      }
    },
    /*
    Input: 10:00:00 => Output: 10a
    Input: 10:30:00 => Output: 10:30a
    */
    compressTimeFormat(djangoTime) {
      const ampmFormat = this.djangotimeformatAMPM(djangoTime);
      if (!ampmFormat) {
        return '';
      }
      let result = ampmFormat;
      result = result.replace(':00', '');
      result = result.replace(' am', 'a');
      result = result.replace(' pm', 'p');
      return result
    },
    // getAge(birthday) {
    //     var today = new Date();
    //     var birthDate = new Date(birthday);
    //     var age = today.getFullYear() - birthDate.getFullYear();
    //     var m = today.getMonth() - birthDate.getMonth();
    //     if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate()))
    //     {
    //         age--;
    //     }
    //     return age;
    // },
    getAge(birthday) {
      if (!birthday) {
        return "";
      }
      var today = new Date();
      var birthDate = new Date(birthday);

      if (birthDate > today) {
        return "Coming soon!";
      } else {
        var age = today.getFullYear() - birthDate.getFullYear();
        var m = today.getMonth() - birthDate.getMonth();
        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
          // if we are in the same month as the birth month, need to check if the birthday has passed or not
          age--;
          m--; // This makes it say 11 months if we are in the birth month but before the birthday
        }
        if (m < 0) {
          m = 12 + m;
        }

        if (age >= 3) {
          return age + " years";
        } else if (age === 1) {
          return age + " year, " + m + " months";
        } else {
          return age + " years, " + m + " months";
        }
      }
    },
    getCompressedAge(birthday) {
      const age = this.getAgeInYears(birthday);
      if (age < 0) {
        return "Coming soon!";
      }
      if (age >= 1) {
        return Math.floor(age) + 'yo';
      } else {
        return Math.round(age * 12) + 'mo';
      }
    },
    getAgeInYears(birthday) {
      const today = new Date();
      const birthDate = new Date(birthday);

      if (birthDate > today) {
        // Don't need to care about exact number
        return -1;
      } else {
        var age = today.getFullYear() - birthDate.getFullYear();
        var m = today.getMonth() - birthDate.getMonth();
        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
          // if we are in the same month as the birth month, need to check if the birthday has passed or not
          age--;
          m--; // This makes it say 11 months if we are in the birth month but before the birthday
        }
        if (m < 0) {
          m = 12 + m;
        }
        return age + m / 12;
      }
    },
    calculateAgeInMonthsAndYears(birthDate) {
      const now = new Date();
      const bDate = new Date(birthDate);
      const diffInMilliseconds = now.getTime() - bDate.getTime();
      let diffInYears = diffInMilliseconds / (1000 * 60 * 60 * 24 * 365);
      if (diffInYears >= 0) {
        diffInYears = Math.floor(
          diffInYears
        );
      } else {
        diffInYears = Math.ceil(diffInYears);
      }
      const diffInMonths = Math.floor(
        (diffInMilliseconds % (1000 * 60 * 60 * 24 * 365)) /
        (1000 * 60 * 60 * 24 * 30)
      );
      if (diffInYears === 0) {
        return diffInMonths + " months";
      }
      return diffInYears + " years, " + diffInMonths + " months";
    },
    convertTimeToAMPM(time) {
      const result = { mm: this.getNumberTwoDigits(time.mm) };
      result.A = time.HH >= 12 ? "PM" : "AM";
      if (time.HH >= 12) {
        if (time.HH === 12) {
          result.hh = "12";
        } else {
          result.hh = this.getNumberTwoDigits(time.HH - 12);
        }
        result.A = "PM";
      } else {
        if (time.HH === 0) {
          result.hh = "12";
        } else {
          result.hh = this.getNumberTwoDigits(time.HH);
        }
        result.A = "AM";
      }
      return result;
    },
    convertAMPMto24Format(time) {
      const result = { mm: this.getNumberTwoDigits(time.mm) };
      let hours = parseInt(time.hh);
      let AMPM = time.A;
      if (AMPM == "PM" && hours < 12) hours = hours + 12;
      if (AMPM == "AM" && hours == 12) hours = hours - 12;
      result.HH = this.getNumberTwoDigits(hours)
      return result;
    },
    getNumberTwoDigits(num) {
      return ("0" + num).slice(-2);
    },
    revertTimeFromAMPM(time) {
      if (!time) {
        return null;
      }
      if (time.A == null || time.hh == null || time.mm == null) {
        return null;
      }
      const result = { HH: Number(time.hh), mm: Number(time.mm) };
      if (time.A === "AM") {
        if (Number(time.hh) === 12) {
          result.HH = 0;
        }
      } else {
        if (Number(time.hh) === 12) {
          result.HH = 12;
        } else {
          result.HH = result.HH + 12;
        }
      }
      return result;
    },
    getTimeString(timeAMPM) {
      if (!timeAMPM) {
        return null;
      }
      if (typeof timeAMPM === 'string') {
        if (timeAMPM.includes('AM') || timeAMPM.includes('PM')) {
          const timeAMPMObj = {
            A: timeAMPM.includes('AM') ? 'AM' : 'PM',
            hh: Number(timeAMPM.match(/^(\d+)/)[1])
          }
          const minutesMatch = timeAMPM.match(/:(\d+)/)
          if (minutesMatch && minutesMatch.length >= 2) {
            timeAMPMObj.mm = Number(minutesMatch[1])
          } else {
            timeAMPMObj.mm = 0;
          }
          timeAMPM = timeAMPMObj;
        } else {
          return timeAMPM;
        }
      }
      const time = this.revertTimeFromAMPM(timeAMPM);
      if (!time) {
        return null;
      }
      return this.getNumberTwoDigits(time.HH) + ":" + this.getNumberTwoDigits(time.mm) + ":00";
    },
    getCurrentTimeString() {
      const now = new Date();
      return this.getNumberTwoDigits(now.getHours()) + ":" + this.getNumberTwoDigits(now.getMinutes()) + ":00";
    },
    getTimeStringFromDateTime(date) {
      return this.getNumberTwoDigits(date.getHours()) + ":" + this.getNumberTwoDigits(date.getMinutes()) + ":00";
    },
    getTimeFromString(timeString) {
      if (!timeString) {
        return null;
      }
      const tokens = timeString.split(":");
      return this.convertTimeToAMPM({
        HH: Number(tokens[0]),
        mm: Number(tokens[1])
      });
    },
    convertTimeStringToStringAMPM(timeString) {
      if (!timeString) {
        return null;
      }
      if (typeof timeString === 'string') {
        if (timeString.includes('AM') || timeString.includes('PM')) {
          return timeString;
        }
      }
      const timeAMPM = this.getTimeFromString(timeString);
      return this.convertTimeAMPMToString(timeAMPM);
    },
    convertTimeAMPMToString(timeAMPM) {
      if (!timeAMPM) {
        return null;
      }
      if (typeof timeAMPM === 'string') {
        return timeAMPM;
      }
      return timeAMPM.hh + ":" + timeAMPM.mm + " " + timeAMPM.A;
    },
    compareTime(time1, time2) {
      if (time1.HH > time2.HH) {
        return 1;
      } else if (time1.HH < time2.HH) {
        return -1;
      } else {
        if (time1.mm > time2.mm) {
          return 1;
        } else if (time1.mm < time2.mm) {
          return -1;
        }
        return 0;
      }
    },
    compareTimeAMPM(timeAMPM1, timeAMPM2) {
      const time1 = this.revertTimeFromAMPM(timeAMPM1);
      const time2 = this.revertTimeFromAMPM(timeAMPM2);
      return this.compareTime(time1, time2);
    },
    compareDuration(startDate, startTimeAMPM, endDate, endTimeAMPM, duration) {
      if (!startDate) {
        startDate = this.dateInDjangoFormat(new Date());
      }
      if (!endDate) {
        endDate = startDate;
      }
      const date1 = new Date(startDate);
      const date2 = new Date(endDate);
      // Validate startDate <= endDate
      if (date1 > date2) {
        return -3;
      }
      // Undefined start time or end time
      if (!startTimeAMPM || !endTimeAMPM) {
        return 0;
      }
      let startTime = startTimeAMPM;
      let endTime = endTimeAMPM;
      if (typeof startTime === "object") {
        startTime = this.getTimeString(startTimeAMPM);
        endTime = this.getTimeString(endTimeAMPM);
      }
      const startTimestamp = new Date(startDate + "T" + startTime).getTime();
      const endTimestamp = new Date(endDate + "T" + endTime).getTime();
      const diff = (endTimestamp - startTimestamp) / 3600000; // Diff in hour
      // Validate starTimestamp <= endTimestamp
      if (startTimestamp > endTimestamp) {
        return -2;
      }
      if (diff < duration) {
        return -1;
      }
      return diff;
    },
    // Calculate duration (from startDate-startTime to endDate-endTime)
    // limitDuration = true => limit booking duration <= 24 hours
    calculateDuration(startDate, startTime, endDate, endTime, breakInfo, limitDuration = false) {
      if (!startDate) {
        startDate = this.dateInDjangoFormat(new Date());
      }
      startDate = this.dateInDjangoFormat(startDate);
      if (startTime) {
        startTime = this.getTimeString(startTime);
      }
      if (endTime) {
        endTime = this.getTimeString(endTime);
      }
      if (limitDuration) {
        if (startTime === endTime) {
          if (endDate && this.dateInDjangoFormat(endDate) === this.getNextDate(startDate)) {
            // 24 hours
            return 24;
          } else {
            // 0 hours
            return 0;
          }
        }
        if (!startTime || !endTime) {
          return null;
        }
        // End date is calculated based on start date. It will prevent the case of incorrect end date of shift job
        endDate = startDate;
      } else {
        if (!endDate || endDate < startDate) {
          endDate = startDate;
        }
      }
      const startTimestamp = new Date(startDate + "T" + startTime).getTime();
      const endTimestamp = new Date(endDate + "T" + endTime).getTime();
      let diff = (endTimestamp - startTimestamp) / 3600000; // Diff in hour
      if (diff < 0) {
        // In this case, endDate is the day after startDate
        diff = diff + 24;
      }
      // Subtract break times
      if (breakInfo && breakInfo.length) {
        const breakDuration = this.calculateSumOfProperty(breakInfo, 'duration');
        diff = diff - breakDuration;
      }
      return diff;
    },
    calculateHoursFromNow(date, time) {
      const currentTimestamp = new Date().getTime();
      date = this.dateInDjangoFormat(date);
      if (!time) {
        time = "00:00:00";
      } else {
        time = this.getTimeString(time);
      }
      const targetTimestamp = new Date(date + "T" + time);
      return (targetTimestamp - currentTimestamp) / 3600000; // Diff in hour
    },
    sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },
    timeDeltaHours(startHour, startMinute, startAMPM, endHour, endMinute, endAMPM) {
      //
      // Used for computing the difference in hours between 2 AMPM times, useful to prevent scheduling time blocks below a length threshold
      //
      let startTime = parseInt(startHour)
      if (startTime == 12) {
        startTime -= 12
      }
      // else {
      //   this.startHour -= 1
      // }
      if (startAMPM == 'PM') {
        // console.log(this.startHour)
        startTime += 12
        // console.log(this.startHour)
      }
      startTime += (parseInt(startMinute) / 60)

      let endTime = parseInt(endHour)
      if (endTime == 12) {
        endTime -= 12
      }
      // else {
      //   this.endHour -= 1
      // }
      if (endAMPM == 'PM') {
        endTime += 12
      }
      endTime += (parseInt(endMinute) / 60)

      return endTime - startTime
    },
    timeDelta24Hours(startTime, endTime) {
      //
      // Used for computing the difference in hours between 2 HH:MM:SS times, useful to calculate the length of a shift job
      //
      let startHours = parseInt(startTime.split(':')[0]) + parseInt(startTime.split(':')[1]) / 60
      let endHours = parseInt(endTime.split(':')[0]) + parseInt(endTime.split(':')[1]) / 60

      return endHours - startHours
    },
    combineTime(hour, minutes, ampm) {
      //
      // Used to combine the pieces of a time into an HH:MM:SS time
      //
      let HH = parseInt(hour)

      // This is to turn 12AM (midnight) into OO (don't have to worry about 12pm, because that will get fixed in the next step)
      if (HH == 12) {
        HH -= 12
      }
      if (ampm == 'PM') {
        HH += 12
      }
      HH = ("0" + HH.toString()).slice(-2); // If the hour is a single digit, this pads it with a 0

      return `${HH}:${minutes}:00`
    },
    dateDayOfTheWeek(date, capitalCase) { // send true as 2nd parameter to get capital case dayName
      // This returns the text name of the day of the week today (eg. monday)
      // Expects the date in javascript format (not django)
      // The purpose of this is for checking candidate availability against a job (see master calendar)
      let dayNum = (date).getDay()
      // They start the days of the week from Sunday (as 0)
      dayNum = dayNum - 1 // Want to turn Monday into 0
      if (dayNum === -1) {
        dayNum = 6 // Need Sunday to be 6
      }

      let days = [
        'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday',
      ]

      return capitalCase ? days[dayNum] : days[dayNum].toLowerCase()
    },
    // Convert date time from local timezone to UTC
    convertTimeToUTC(inputTime) {
      const date = new Date(inputTime);
      const utc = new Date(date.getTime() + date.getTimezoneOffset() * 60000);
      return (
        utc.getFullYear().toString() +
        "-" +
        ("0" + (utc.getMonth() + 1).toString()).slice(-2) +
        "-" +
        ("0" + utc.getDate().toString()).slice(-2) +
        "T" +
        ("0" + utc.getHours().toString()).slice(-2) +
        ":" +
        ("0" + utc.getMinutes().toString()).slice(-2) +
        ":" +
        ("0" + utc.getSeconds().toString()).slice(-2)
      );
    },
    convertEventToLocalTime(event) {
      if (event.is_convert_datetime) {
        return new Date(event.datetime);
      } else {
        return this.convertUTCToLocalTime(event.datetime);
      }
    },
    convertUTCToLocalTime(inputTime) {
      if (!inputTime) {
        return null;
      }
      // Check to remove last -04:00
      const tokens = inputTime.split('-');
      if (tokens.length >= 4) {
        inputTime = tokens[0] + '-' + tokens[1] + '-' + tokens[2];
      }
      if (inputTime.endsWith('Z')) {
        return new Date(inputTime);
      }
      return new Date(inputTime + 'Z');
    },
    // Calculate diff in years between two date
    calculateDiffYears(startDateString, endDateString) {
      const startDate = new Date(startDateString);
      const endDate = new Date(endDateString);
      const diffMonth =
        endDate.getFullYear() * 12 +
        endDate.getMonth() -
        (startDate.getFullYear() * 12 + startDate.getMonth());
      return Math.round(diffMonth / 12);
    },
    // Calculate diff time (input format: AMPM)
    calculateDiffTime(startTimeAMPM, endTimeAMPM) {
      if (!startTimeAMPM.hh || !startTimeAMPM.mm || !startTimeAMPM.A) {
        return null;
      }
      if (!endTimeAMPM.hh || !endTimeAMPM.mm || !endTimeAMPM.A) {
        return null;
      }
      const startTime = this.revertTimeFromAMPM(startTimeAMPM);
      const endTime = this.revertTimeFromAMPM(endTimeAMPM);
      const diffMinutes = (endTime.HH * 60 + endTime.mm) - (startTime.HH * 60 + startTime.mm);
      if (diffMinutes < 0) {
        return "---"
      }
      const hours = Math.floor(diffMinutes / 60);
      let minutes = diffMinutes % 60;
      minutes = minutes < 10 ? "0" + minutes : minutes;
      return hours + ":" + minutes;
    },
    // Compare endTime - startTime with a number of hours (for example: 2 hours) - delta
    // Return
    //  null: missing information
    //  -1: startTime > endTime
    //  0: valid (endTime - startTime >= delta)
    // 1: invalid (endTime - startTime < delta)
    compareDiffTimeWithHours(startTimeAMPM, endTimeAMPM, delta) {
      if (!startTimeAMPM || !endTimeAMPM) {
        return null;
      }
      if (!startTimeAMPM.hh || !startTimeAMPM.mm || !startTimeAMPM.A) {
        return null;
      }
      if (!endTimeAMPM.hh || !endTimeAMPM.mm || !endTimeAMPM.A) {
        return null;
      }
      const startTime = this.revertTimeFromAMPM(startTimeAMPM);
      const endTime = this.revertTimeFromAMPM(endTimeAMPM);
      if (endTime.HH === 0 && endTime.mm === 0) {
        // In case 12pm of next day
        endTime.HH = 24;
      }
      const diffMinutes = (endTime.HH * 60 + endTime.mm) - (startTime.HH * 60 + startTime.mm);
      if (diffMinutes < 0) {
        return -1;
      }
      const hours = Math.floor(diffMinutes / 60);
      return hours >= delta ? 0 : 1;
    },
    getYearFromDate(date) {
      if (date == null) {
        return null;
      }
      if (typeof date === 'string') {
        return date.split('-')[0];
      }
      return new Date(date).getFullYear();
    },
    convertTimeToInHours(time) {
      if (!time) {
        return null;
      }
      return parseInt(time.split(":")[0]) +
        parseInt(time.split(":")[1]) / 60;
    },
    calculateDiffTimeInHours(time1, time2) {
      const inHours1 = this.convertTimeToInHours(time1);
      const inHours2 = this.convertTimeToInHours(time2);
      return inHours2 - inHours1;
    },
    // Check if the time range specified by [startTime1, endTime1] is overlap with time specified between 2 hour parameters
    isTimeRangeOverlap(startTime1, endTime1, startTime2, endTime2) {
      // Convert from time to 'inHours'
      const startInHours1 = this.convertTimeToInHours(startTime1);
      const endInHours1 = this.convertTimeToInHours(endTime1);
      const startInHours2 = this.convertTimeToInHours(startTime2);
      const endInHours2 = this.convertTimeToInHours(endTime2);

      // If the start time or end time of either job falls within the time range of the other job, there is a conflict
      if (
        (startInHours1 >= startInHours2 && startInHours1 <= endInHours2) ||
        (endInHours1 >= startInHours2 && endInHours1 <= endInHours2) ||
        (startInHours2 >= startInHours1 && startInHours2 <= endInHours1) ||
        (endInHours2 >= startInHours1 && endInHours2 <= endInHours1)
      ) {
        return true;
      }
      return false;
    },
    /*
    Check if time specified by checkDate-checkTime is in range which is specified by startDate-startTime and endDate-endTime
    */
    isTimeInRange(startDate, startTime, endDate, endTime, checkDate, checkTime) {
      const time1 = new Date(
        startDate + "T" + this.getTimeString(startTime)
      ).getTime();
      const time2 = new Date(
        endDate + "T" + this.getTimeString(endTime)
      ).getTime();
      const time3 = new Date(
        checkDate + "T" + this.getTimeString(checkTime)
      ).getTime();
      if ((time1 <= time3) && (time3 <= time2)) {
        return true;
      }
      return false;
    },
    /*
    Split time range to find ranges between time1, time2
    */
    splitTimeRanges(startDate, startTime, endDate, endTime, time1, time2) {
      const time1String = this.getTimeString(time1);
      const time2String = this.getTimeString(time2);
      // Get list dates between startDate and endDate
      const listDates = this.getDatesInRange(startDate, endDate);
      const listPivot = [];
      for (const date of listDates) {
        if (this.isTimeInRange(startDate, startTime, endDate, endTime, date, time1)) {
          listPivot.push(date + "T" + this.getTimeString(time1));
        }
        if (this.isTimeInRange(startDate, startTime, endDate, endTime, date, time2)) {
          listPivot.push(date + "T" + this.getTimeString(time2));
        }
      }
      if (!listPivot.includes(startDate + "T" + this.getTimeString(startTime))) {
        listPivot.push(startDate + "T" + this.getTimeString(startTime))
      }
      if (!listPivot.includes(endDate + "T" + this.getTimeString(endTime))) {
        listPivot.push(endDate + "T" + this.getTimeString(endTime))
      }
      listPivot.sort((date1, date2) => date1 < date2 ? -1 : 1);
      const listRanges = [];
      for (let index = 0; index < listPivot.length - 1; index++) {
        listRanges.push([listPivot[index], listPivot[index + 1]]);
      }
      const listValidRange = [];
      if (listRanges.length === 1) {
        // There is only one range, which is specified by start date - start time and end date - end time
        const start = listRanges[0][0];
        const end = listRanges[0][1];
        if (start.includes(time1String) && end.includes(time2String)) {
          listValidRange.push(listRanges[0]);
        }
      } else {
        for (const range of listRanges) {
          const start = range[0];
          const end = range[1];
          if (start.includes(time2String) || end.includes(time1String)) {
            continue;
          }
          listValidRange.push(range);
        }
      }
      return listValidRange;

    },
    // Get dates between startDate and endDate
    getDatesInRange(startDate, endDate, excludeWeekends = false) {
      const result = [];
      if (!startDate || !endDate) {
        return [];
      }
      var currentDate = startDate;
      while (currentDate <= endDate) {
        if (excludeWeekends) {
          const dateObj = new Date(
            this.addCurrentTimeToDate(currentDate)
          );
          const dayOfWeek = dateObj.getDay();
          if (dayOfWeek > 0 && dayOfWeek < 6) {
            result.push(currentDate);
          }
        } else {
          result.push(currentDate);
        }
        currentDate = this.getNextDate(currentDate);
      }
      return result;
    },
    getNextDate(startDate) {
      let date;
      if (typeof startDate === 'object') {
        date = new Date(startDate.getTime());
      } else {
        if (startDate.includes(':')) {
          date = new Date(startDate);
        } else {
          date = new Date(startDate + 'T00:00:00');
        }
      }
      date.setDate(date.getDate() + 1);
      return this.dateInDjangoFormat(date);
    },
    getDateAfterDays(startDate, numberOfDay) {
      let date;
      if (typeof startDate === 'object') {
        date = new Date(startDate.getTime());
      } else {
        if (startDate.includes(':')) {
          date = new Date(startDate);
        } else {
          date = new Date(startDate + 'T00:00:00');
        }
      }
      date.setDate(date.getDate() + numberOfDay);
      return this.dateInDjangoFormat(date);
    },
    // Format of startTime, endTime: date + 'T' + time
    calculateDurationInHours(startTime, endTime) {
      const time1 = new Date(startTime).getTime();
      const time2 = new Date(endTime).getTime();
      return (time2 - time1) / 3600000; // Diff in hour
    },
    calculateSecondDiffBetweenDates(date1, date2) {
      const diff = date2.getTime() - date1.getTime();
      const seconds = Math.round(diff / 1000);
      return seconds;
    },
    calculateReadableSecondDiff(seconds) {
      let minutes = seconds / 60;
      let result;
      if (minutes >= 1) {
        minutes = Math.floor(minutes)
        let hours = minutes / 60;
        if (hours >= 1) {
          hours = Math.floor(hours)
          let days = hours / 24;
          if (days >= 1) {
            days = Math.floor(days)
            result = `${days} days, ${hours % 24} hours`
          } else {
            result = `${hours} hours, ${minutes % 60} minutes`
          }
        } else {
          result = `${minutes} minutes, ${seconds % 60} seconds`
        }
      } else {
        result = `${seconds} seconds`
      }
      // Handle singular word
      const tokens = result.split(',');
      const correctedTokens = [];
      for (const token of tokens) {
        let correctedToken = token.trim();
        if (correctedToken.startsWith('0 ')) {
          continue;
        }
        if (correctedToken.startsWith('1 ')) {
          // Remove ending s
          correctedToken = correctedToken.slice(0, -1);
        }
        correctedTokens.push(correctedToken);
      }
      return correctedTokens.join(', ');
    },
    // Input: yyyy-MM-dd, example: 2020-10-30
    // Output: MMM yyyy, example: Oct 2020
    getDisplayMonthYear(dateString) {
      const tokens = dateString.split("-");
      if (tokens.length < 2) {
        return dateString;
      }
      const monthShort = this.$store.getters.months.find(
        (month) => month.number === tokens[1]
      ).short;
      return monthShort + " " + tokens[0];
    },
    getDisplayMonthDay(dateString) {
      if (!dateString) {
        return "";
      }
      const tokens = dateString.split("-");
      if (tokens.length < 3) {
        return dateString;
      }
      const monthShort = this.$store.getters.months.find(
        (month) => month.number === tokens[1]
      ).short;
      return monthShort + " " + tokens[2];
    },
    getDisplayMonthDayYear(dateString) {
      if (!dateString) {
        return "";
      }
      const tokens = dateString.split("-");
      if (tokens.length < 3) {
        return dateString;
      }
      const monthShort = this.$store.getters.months.find(
        (month) => month.number === tokens[1]
      ).short;
      const day = tokens[2];
      const ordinal = this.getOrdinal(day);
      return `${monthShort} ${day}${ordinal}, ${tokens[0]}`
    },
    getOrdinal(d) {
      if (d > 3 && d < 21) return 'th';
      switch (d % 10) {
        case 1: return "st";
        case 2: return "nd";
        case 3: return "rd";
        default: return "th";
      }
    },
    // Check if inputDate is in the past
    isPastDate(inputDate) {
      if (!inputDate) {
        return null;
      }
      const date = new Date(inputDate + "T23:59:59");
      return date < new Date();
    },
    isTimeFilled(time) {
      return time && time.hh && time.mm && time.A;
    },
    getDayOfWeek(date) {
      if (typeof date === 'string') {
        if (date.includes('T')) {
          date = new Date(date)
        } else {
          date = new Date(
            this.addCurrentTimeToDate(date)
          );
        }
      }

      let dayNum = date.getDay(); // https://www.w3schools.com/jsref/jsref_getday.asp
      // Javscript starts the days of the week from Sunday (as 0)
      dayNum = dayNum - 1; // Want to turn Monday into 0
      if (dayNum === -1) {
        dayNum = 6; // Need Sunday to be 6
      }

      return this.$store.getters.days[dayNum].toLowerCase();
    },
    addTimeToDate(date) {
      if (!date) {
        return null;
      }
      if (typeof date === 'object') {
        return date;
      }
      if (date.includes('T')) {
        return new Date(date);
      }
      return new Date(date + "T00:00:00");
    },
    isAllDayBlock(startTime, endTime) {
      return startTime === '00:00:00' && endTime === '23:59:59';
    },
    convertDate(input, fromFormat, toFormat) {
      if (!input || !input.trim()) {
        return null;
      }
      if (!fromFormat || !toFormat) {
        return input;
      }
      try {
        const date = dateTime.parse(input, fromFormat);
        return dateTime.format(date, toFormat);
      } catch (e) {
        return input;
      }
    },
    // Check if date is between startDate and startDate + duration (duration is in months)
    isDateInRange(date, startDate, numberOfMonth) {
      const dateStr = this.dateInDjangoFormat(this.addTimeToDate(date));
      const startDateObj = this.addTimeToDate(startDate);
      const startDateStr = this.dateInDjangoFormat(startDateObj);
      if (dateStr < startDateStr) {
        return false;
      }
      const endDateObj = this.addMonthsToDate(numberOfMonth, startDateObj);
      const endDateStr = this.dateInDjangoFormat(endDateObj);
      return dateStr <= endDateStr;
    },
    addMonthsToDate(numberOfMonth, date) {
      if (!date) {
        date = new Date();
      } else {
        date = new Date(date.getTime());
      }
      // https://stackoverflow.com/questions/3818193/how-to-add-number-of-days-to-todays-date
      date = date.setMonth(date.getMonth() + numberOfMonth); // https://stackoverflow.com/questions/11343939/how-to-add-weeks-to-date-using-javascript
      return new Date(date);
    },
    // Split date by week, month or year
    // For example: [2022-01-01, 2022-02-01], [2022-02-01, 2022-03-01]
    // Unit: Week, Month, Year
    splitDateRange(startDate, numberOfMonth) {
      const startDateObj = this.addTimeToDate(startDate);
      const startDateStr = this.dateInDjangoFormat(startDateObj);
      const endDateObj = this.addMonthsToDate(numberOfMonth, startDateObj);
      const endDateStr = this.dateInDjangoFormat(endDateObj);
      const listPivot = [startDateStr];
      let pivot = this.addMonthsToDate(1, startDateObj);
      while (this.dateInDjangoFormat(pivot) < endDateStr) {
        listPivot.push(this.dateInDjangoFormat(pivot));
        pivot = this.addMonthsToDate(1, pivot);
      }
      listPivot.push(endDateStr);
      const result = [];
      for (let index = 0; index < listPivot.length - 1; index++) {
        result.push([listPivot[index], this.getPreviousDate(listPivot[index + 1])]);
      }
      return result;
    },
    subtractDateByHour(date, time, numberOfHours) {
      if (!time) {
        time = '00:00:00';
      }
      const dateObj = new Date(date + 'T' + time);
      const resultObj = new Date(dateObj.getTime() - Number(numberOfHours) * 3600000);
      return {
        date: this.dateInDjangoFormat(resultObj),
        time: this.getNumberTwoDigits(resultObj.getHours()) + ":" + this.getNumberTwoDigits(resultObj.getMinutes()) +
          ":" + this.getNumberTwoDigits(resultObj.getSeconds())
      }
    },
    addDateByHour(date, time, numberOfHours) {
      if (!time) {
        time = '00:00:00';
      }
      const dateObj = new Date(date + 'T' + time);
      const resultObj = new Date(dateObj.getTime() + Number(numberOfHours) * 3600000);
      return {
        date: this.dateInDjangoFormat(resultObj),
        time: this.getNumberTwoDigits(resultObj.getHours()) + ":" + this.getNumberTwoDigits(resultObj.getMinutes()) +
          ":" + this.getNumberTwoDigits(resultObj.getSeconds())
      }
    },
    getMonthsBetweenDates(startDate, endDate) {
      const start = startDate.split('-');
      const end = endDate.split('-');
      const startYear = parseInt(start[0]);
      const endYear = parseInt(end[0]);
      const dates = [];

      for (let i = startYear; i <= endYear; i++) {
        const endMonth = i != endYear ? 11 : parseInt(end[1]) - 1;
        const startMon = i === startYear ? parseInt(start[1]) - 1 : 0;
        for (let j = startMon; j <= endMonth; j = j > 12 ? j % 12 || 11 : j + 1) {
          const month = j + 1;
          const displayMonth = month < 10 ? '0' + month : month;
          dates.push([i, displayMonth].join('-'));
        }
      }
      return dates;
    },
    getMonthYearFromDate(dateString) {
      const tokens = dateString.split('-');
      tokens.pop();
      return tokens.join('-');
    },
    getStartDayOfCurrentWeek(currentDate) {
      // This returns the Monday or Sunday (starting day) of the current week being viewed
      let startDate = new Date();
      if (currentDate) {
        startDate = new Date(currentDate.getTime());
      }
      // Need to put the days in order starting with the day of the week associated with the selected day
      let dayNum = startDate.getDay(); // https://www.w3schools.com/jsref/jsref_getday.asp
      if (this.$store.getters.startDayOfWeekCalendar === 1) {
        // They start the days of the week from Sunday (as 0)
        dayNum = dayNum - 1; // Want to turn Monday into 0
        if (dayNum === -1) {
          dayNum = 6; // Need Sunday to be 6
        }
      }

      // We want to subtract the number of days ahead of the current show date to bring us back to Monday
      // https://stackoverflow.com/questions/3818193/how-to-add-number-of-days-to-todays-date
      // Start day of week is Monday
      startDate = startDate.setDate(startDate.getDate() - dayNum); // https://stackoverflow.com/questions/11343939/how-to-add-weeks-to-date-using-javascript
      startDate = new Date(startDate);

      return startDate;
    },
    getEndDayOfCurrentWeek(currentDate) {
      // This returns the Sunday or Saturday (ending day) of the current week being viewed

      let endDate = new Date();
      if (currentDate) {
        endDate = new Date(currentDate.getTime());
      }

      // Need to put the days in order starting with the day of the week associated with the selected day
      let dayNum = endDate.getDay(); // https://www.w3schools.com/jsref/jsref_getday.asp
      // console.log(dayNum)
      // They start the days of the week from Sunday (as 0)
      if (this.$store.getters.startDayOfWeekCalendar === 1) {
        dayNum = dayNum - 1; // Want to turn Monday into 0
        if (dayNum === -1) {
          dayNum = 6; // Need Sunday to be 6
        }
      }

      // We want to add the number of days missing from the current show date to bring us forward to Sunday
      // https://stackoverflow.com/questions/3818193/how-to-add-number-of-days-to-todays-date
      // End day is Sunday
      endDate = endDate.setDate(endDate.getDate() + (6 - dayNum)); // https://stackoverflow.com/questions/11343939/how-to-add-weeks-to-date-using-javascript
      endDate = new Date(endDate);

      return endDate;
    },
    getDisplayTime(timestamp) {
      const date = new Date(timestamp);
      let hours = date.getHours();
      let minutes = date.getMinutes();
      let ampm = hours >= 12 ? "pm" : "am";
      hours = hours % 12;
      hours = hours ? hours : 12; // the hour '0' should be '12'
      minutes = minutes < 10 ? "0" + minutes : minutes;
      const time = hours + ":" + minutes + " " + ampm;
      // Check if it is today
      if (this.dateInDjangoFormat(date) === this.todayDjangoFormat) {
        return time;
      } else {
        return (
          date.getMonth() +
          1 +
          "/" +
          date.getDate() +
          "/" +
          date.getFullYear().toString().substr(-2) +
          ` ${time}`
        );
      }
    },
    // Function to calculate the number of days between two dates
    getDaysBetweenDates(startDate, endDate) {
      const oneDay = 24 * 60 * 60 * 1000; // Number of milliseconds in a day
      const start = new Date(startDate);
      const end = new Date(endDate);

      // Calculate the difference in days
      const diffDays = Math.round(Math.abs((start - end) / oneDay));

      return diffDays;
    }
  }
});



// WEBPACK FOOTER //
// ./src/mixins/datetime-handling.js